/** How many people have run a published template, said in words rather than as a bare number. */
export function ranLabel(count: number): string {
  if (count === 0) {
    return 'Nobody has run this yet'
  }
  return count === 1 ? '1 person has run this' : `${String(count)} people have run this`
}
